import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false
};

const setInitialLoading = () => ({
  loading: true
});

const fetchDataStart = (state) => ({
  ...state
});

const fetchDataSuccess = (state, action) => ({
  ...state,
  loading: false,
  ...action.data
});

const fetchDataFail = (state) => ({
  ...state
});

const setCardsLoading = (state, action) => ({
  ...state,
  bucketData: {
    ...state.bucketData,
    [action.id]: {
      ...state.bucketData[action.id],
      loading: true
    }
  }
});

const setSecondaryBucket = (state, action) => ({
  ...state,
  ...action.newData
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_INITIAL_LOADING:
      return setInitialLoading(state, action);

    case actionTypes.FETCH_PIPELINE_DATA_START:
      return fetchDataStart(state, action);

    case actionTypes.FETCH_PIPELINE_DATA_SUCCESS:
      return fetchDataSuccess(state, action);

    case actionTypes.FETCH_PIPELINE_DATA_FAIL:
      return fetchDataFail(state, action);

    case actionTypes.SET_CARDS_LOADING_TRUE:
      return setCardsLoading(state, action);

    case actionTypes.SET_SECONDARY_BUCKET:
      return setSecondaryBucket(state, action);

    default:
      return state;
  }
};

export default reducer;
